// Deterministic per-page Open Graph artwork.
//
// Every state / game URL gets one of several distinct social images, chosen by
// a stable hash of its slug. Combined with the per-page title used as
// og:image:alt, this keeps social previews visually distinct instead of every
// URL sharing one template image.

import state1 from "@/assets/og/state-1.jpg";
import state2 from "@/assets/og/state-2.jpg";
import state3 from "@/assets/og/state-3.jpg";
import state4 from "@/assets/og/state-4.jpg";
import game1 from "@/assets/og/game-1.jpg";
import game2 from "@/assets/og/game-2.jpg";
import game3 from "@/assets/og/game-3.jpg";
import game4 from "@/assets/og/game-4.jpg";

const STATE_OG = [state1, state2, state3, state4];
const GAME_OG = [game1, game2, game3, game4];

/** Stable, platform-independent 32-bit string hash (FNV-1a). */
function hashSlug(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

export function stateOgImage(stateSlug: string): string {
  return STATE_OG[hashSlug(`state:${stateSlug}`) % STATE_OG.length];
}

export function gameOgImage(gameSlug: string, stateSlug?: string): string {
  const key = stateSlug ? `game:${stateSlug}:${gameSlug}` : `game:${gameSlug}`;
  return GAME_OG[hashSlug(key) % GAME_OG.length];
}
